import { usePostDataMutation } from "@/core/api/api";
import { endpoints } from "@/core/api/endpoints";
import { ApiResponse } from "@/interface/error.interface";
import handleErrors from "@/utils/handleError";
import {
  showErrorMessage,
  showSuccessMessage,
} from "@/utils/toastMessage/toast.message";
import { useFormik } from "formik";
import * as Yup from "yup";

interface IFormValues {
  fullname: string;
  email: string;
  phone: string;
  package: string;
  message: string;
}
export const useContactForm = () => {
  const [postContact, { isLoading }] = usePostDataMutation();

  const formik = useFormik<IFormValues>({
    initialValues: {
      fullname: "",
      email: "",
      phone: "",
      package: "",

      message: "",
    },
    validationSchema: Yup.object({
      fullname: Yup.string()
        .matches(
          /^[A-Za-z\s'-]+$/,
          "Name can not contain numbers or special characters"
        )
        .required("Name is required"),
      email: Yup.string()
        .required("Email is required")
        .email("Invalid email format"),
      phone: Yup.string()
        .required("Phone number is required")
        .matches(/^[0-9]{10}$/, "Phone number must be 10 digits"),
      service: Yup.string()
        .required("Subject is required")
        .min(3, "Subject must be at least 3 characters"),
      message: Yup.string()
        .required("Message is required")
        .min(10, "Message must be at least 10 characters"),
    }),

    onSubmit: async (values) => {
      try {
        const response = (await postContact({
          url: `${endpoints.CONTACT}`,
          data: {
            ...values,
          },
        })) as ApiResponse;
        if (response.error) {
          console.error("Signup error:", response.error);
          handleErrors(response as ApiResponse, formik.setErrors);
          showErrorMessage(response.error.data.message);
        }

        if (response.data) {
          showSuccessMessage(response.data.message);
          formik.resetForm();
        }
      } catch (error) {
        console.error("Failed to submit contact information:", error);
      }
    },
  });

  return {
    formik,
    isLoading,
  };
};
